const hidden_overlay = document.getElementById('hidden-overlay');

const nail_picker_1 = document.getElementById('nail-picker-1');   
const nail_picker_2 = document.getElementById('nail-picker-2');

const nail_picker_titles_1 = document.querySelectorAll('.nail-picker-title-1');
const nail_picker_titles_2 = document.querySelectorAll('.nail-picker-title-2');

const close_button_1 = document.getElementById('nail-picker-1-close-button'); 
const close_button_2 = document.getElementById('nail-picker-2-close-button'); 

const selected_colors_1 = document.querySelectorAll('.nail-picker-selected-color-1');
const selected_colors_2 = document.querySelectorAll('.nail-picker-selected-color-2');

const remove_selected_colors_1 = document.querySelectorAll('.remove-selected-color-1');
const remove_selected_colors_2 = document.querySelectorAll('.remove-selected-color-2');

const selected_colors_modal_1 = document.querySelectorAll('.nail-picker-selected-color-modal-1');
const selected_colors_modal_2 = document.querySelectorAll('.nail-picker-selected-color-modal-2');

const selected_colors_count_1 = document.getElementById('nail-picker-selected-colors-count-1');
const selected_colors_count_2 = document.getElementById('nail-picker-selected-colors-count-2');

const nail_picker_progress_bar_1 = document.getElementById('nail-picker-progress-bar-1');
const nail_picker_progress_bar_2 = document.getElementById('nail-picker-progress-bar-2');

const remove_selected_colors_modal_1 = document.querySelectorAll('.remove-selected-color-modal-1');
const remove_selected_colors_modal_2 = document.querySelectorAll('.remove-selected-color-modal-2');

const color_items_1 = document.querySelectorAll('.nail-picker-color-1');
const color_items_2 = document.querySelectorAll('.nail-picker-color-2');

const product_form = document.querySelector('.main-product-form');
const main_atc_button = document.getElementById('byteex-submit-button');
const atc_button_text = document.getElementById('atc-button-text');
const choose_color_button_text = document.getElementById('choose-color-button-text');

// ---------------------------------------------------------------

// POPUP BOXES
const popup_box_open_1 = document.querySelector('.nail-picker-updated-popup-box-open-1');
const popup_box_open_2 = document.querySelector('.nail-picker-updated-popup-box-open-2');

const popup_box_1 = document.querySelector('.nail-picker-updated-popup-box-1');
const popup_box_2 = document.querySelector('.nail-picker-updated-popup-box-2');

const popup_box_close_1 = document.querySelector('.nail-picker-updated-popup-box-close-1');
const popup_box_close_2 = document.querySelector('.nail-picker-updated-popup-box-close-2');

if (popup_box_open_1 && popup_box_1 && popup_box_close_1) {
  popup_box_open_1.addEventListener('click', () => {
    popup_box_1.style.display = 'block';
    close_button_1.style.display = 'none';
  });

  popup_box_close_1.addEventListener('click', () => {
    popup_box_1.style.display = 'none';
    close_button_1.style.display = 'flex';
  });
}

if (popup_box_open_2 && popup_box_2 && popup_box_close_2) {
  popup_box_open_2.addEventListener('click', () => {
    popup_box_2.style.display = 'block';
    close_button_2.style.display = 'none';
  });

  popup_box_close_2.addEventListener('click', () => {
    popup_box_2.style.display = 'none';
    close_button_2.style.display = 'flex';
  });
}

// ---------------------------------------------------------------

// COLORS FILTER
const nail_picker_filter_items_1 = document.querySelectorAll('.nail-picker-color-filter-item-1');
nail_picker_filter_items_1.forEach((item, index, array) => {
  item.addEventListener('click', (event) => {
    const filter_value = event.currentTarget.dataset.value;

    item.classList.add('font-bold');
    array.forEach(i => {
      if (i !== item) {
        i.classList.remove('font-bold');
      }
    });

    color_items_1.forEach(color => {
      const filters = color.dataset.filters.toLowerCase();

      if (filters.includes(filter_value) || filter_value === 'All') {
        color.classList.remove('hidden');
      } else {
        color.classList.add('hidden');
      }
    });
  });
});

const nail_picker_filter_items_2 = document.querySelectorAll('.nail-picker-color-filter-item-2');
nail_picker_filter_items_2.forEach((item, index, array) => {
  item.addEventListener('click', (event) => {
    const filter_value = event.currentTarget.dataset.value;

    item.classList.add('font-bold');
    array.forEach(i => {
      if (i !== item) {
        i.classList.remove('font-bold');
      }
    });

    color_items_2.forEach(color => {
      const filters = color.dataset.filters.toLowerCase();

      if (filters.includes(filter_value) || filter_value === 'All') {
        color.classList.remove('hidden');
      } else {
        color.classList.add('hidden');
      }
    });
  });
});

// ---------------------------------------------------------------

// CLOSE NAIL PICKER WINDOW
function closeOnClickOutside1(event) {
  if (nail_picker_1 && !nail_picker_1.contains(event.target)) {
    hidden_overlay.style.display = 'none';
    nail_picker_1.style.display = 'none';        
    document.body.style.overflow = 'auto';
    document.removeEventListener('click', closeOnClickOutside1);
  }
}

function closeOnClickOutside2(event) {
  if (nail_picker_2 && !nail_picker_2.contains(event.target)) {
    hidden_overlay.style.display = 'none';
    nail_picker_2.style.display = 'none';        
    document.body.style.overflow = 'auto';
    document.removeEventListener('click', closeOnClickOutside2);
  }
}

close_button_1.addEventListener('click', () => {
  hidden_overlay.style.display = 'none';
  nail_picker_1.style.display = 'none';        
  document.body.style.overflow = 'auto';
  document.removeEventListener('click', closeOnClickOutside1);
});

close_button_2.addEventListener('click', () => {
  hidden_overlay.style.display = 'none';
  nail_picker_2.style.display = 'none';        
  document.body.style.overflow = 'auto';
  document.removeEventListener('click', closeOnClickOutside2);
});

// ---------------------------------------------------------------

// OPEN NAIL PICKER WINDOW
selected_colors_1.forEach(color => {
  color.addEventListener('click', () => {
    if (nail_picker_1) {
      hidden_overlay.style.display = 'block';
      nail_picker_1.style.display = 'flex';
      document.body.style.overflow = 'hidden';

      setTimeout(() => {
        document.addEventListener('click', closeOnClickOutside1);
      }, 100);
    }
  });
});

selected_colors_2.forEach(color => {
  color.addEventListener('click', () => {
    if (nail_picker_2) {
      hidden_overlay.style.display = 'block';
      nail_picker_2.style.display = 'flex';
      document.body.style.overflow = 'hidden';

      setTimeout(() => {
        document.addEventListener('click', closeOnClickOutside2);
      }, 100);
    }
  });
});

if (main_atc_button) {
  main_atc_button.addEventListener('click', () => {
    const button_type = main_atc_button.type;

    if (button_type === 'button') {
      const hasFirstPickerUnselected = [...selected_colors_1].some(color => {
        const isSelected = color.dataset.selected;
        return isSelected === 'false' || !isSelected;
      });
      
      const hasSecondPickerUnselected = [...selected_colors_2].some(color => {
        const isSelected = color.dataset.selected;
        return isSelected === 'false' || !isSelected;
      });
      
      if (hasFirstPickerUnselected) {
        hidden_overlay.style.display = 'block';
        nail_picker_1.style.display = 'flex';
        document.body.style.overflow = 'hidden';

        setTimeout(() => {
          document.addEventListener('click', closeOnClickOutside1);
        }, 100);
      }
      
      if (!hasFirstPickerUnselected && hasSecondPickerUnselected) {
        hidden_overlay.style.display = 'block';
        nail_picker_2.style.display = 'flex';
        document.body.style.overflow = 'hidden';

        setTimeout(() => {
          document.addEventListener('click', closeOnClickOutside2);
        }, 100);
      }
    }
  });
}

// ---------------------------------------------------------------

// ADD COLORS TO PICKER
function getSelectedCount1() {
  let count = 0;
  selected_colors_1.forEach(color => {
    const isSelected = color.dataset.selected;
    if (isSelected) {
      count++;
    }
  });

  return count;
}

function getSelectedCount2() {
  let count = 0;
  selected_colors_2.forEach(color => {
    const isSelected = color.dataset.selected;
    if (isSelected) {
      count++;
    }
  });

  return count;
}

function addColor1(id, image, title) {
  for (const color of selected_colors_1) {
    const isSelected = color.dataset.selected;

    if (!isSelected) {
      const img = color.querySelector('img');
      img.src = image;

      const color_name = color.querySelector('p');
      color_name.textContent = title;

      const plus_icon = color.querySelector('span');
      plus_icon.style.display = 'none';

      const remove_button = color.querySelector('.remove-selected-color-1');
      remove_button.style.display = 'block';
      
      color.dataset.selected = true;
      color.dataset.id = id;
      break;
    }
  }

  for (const color of selected_colors_modal_1) {
    const isSelected = color.dataset.selected;

    if (!isSelected) {
      const img = color.querySelector('img');
      img.src = image;

      const color_plus = color.querySelector('span');
      color_plus.style.display = 'none';

      const color_name = color.querySelector('p');
      color_name.textContent = title;

      const remove_button = color.querySelector('.remove-selected-color-modal-1');
      remove_button.style.display = 'block';
      
      color.dataset.selected = true;
      break;
    }
  }

  const count = getSelectedCount1();
  selected_colors_count_1.textContent = count;

  if (nail_picker_progress_bar_1) {
    nail_picker_progress_bar_1.style.width = `${(100 / colors_number_1) * count}%`;
  }

  if (count === colors_number_1) {
    const current_properties_block = document.getElementById('nail-picker-properties-block');
    if (current_properties_block) {
      current_properties_block.remove();
    }

    nail_picker_titles_1[0].style.display = 'none';
    nail_picker_titles_1[1].style.display = 'block';

    const hasSecondPickerUnselected = [...selected_colors_2].some(color => {
      const isSelected = color.dataset.selected;
      return isSelected === 'false' || !isSelected;
    });

    if (!hasSecondPickerUnselected) {
      atc_button_text.style.display = 'flex';
      choose_color_button_text.style.display = 'none';
      main_atc_button.type = 'submit';
    }    

    const properties_block = document.createElement('div');
    properties_block.setAttribute('id', 'nail-picker-properties-block');
    
    selected_colors_1.forEach((color, i) => {
      const id = color.dataset.id;

      const text_tag = color.querySelector('p');
      const title = text_tag.textContent;

      const img_tag = color.querySelector('img');
      const image = img_tag.src;

      const hiddenField1 = document.createElement('input');
      hiddenField1.setAttribute('type', "hidden");
      hiddenField1.setAttribute('class', `class${i + 1}`);
      hiddenField1.setAttribute('name', `properties[_${i + 1}.]`);
      hiddenField1.setAttribute('value', image);
      properties_block.appendChild(hiddenField1);        

      const hiddenField2 = document.createElement('input');
      hiddenField2.setAttribute('type', "hidden");
      hiddenField2.setAttribute('class', `class${i + 1}`);
      if (picker_type_1 === 'chrome') {
        hiddenField2.setAttribute('name', `properties[Chrome ${i + 1}]`);
      } else {
        hiddenField2.setAttribute('name', `properties[Colour ${i + 1}]`);
      }
      hiddenField2.setAttribute('value', title);
      properties_block.appendChild(hiddenField2);

      const hiddenField3 = document.createElement('input');
      hiddenField3.setAttribute('type', "hidden");
      hiddenField3.setAttribute('class', `class${i + 1}`);
      hiddenField3.setAttribute('name', `properties[_id${i + 1}.]`);
      hiddenField3.setAttribute('value', id);
      properties_block.appendChild(hiddenField3);
    });

    product_form.appendChild(properties_block);

    hidden_overlay.style.display = 'none';
    nail_picker_1.style.display = 'none';        
    document.body.style.overflow = 'auto';
    document.removeEventListener('click', closeOnClickOutside1);
  }
}

function addColor2(id, image, title) {
  for (const color of selected_colors_2) {
    const isSelected = color.dataset.selected;

    if (!isSelected) {
      const img = color.querySelector('img');
      img.src = image;

      const color_name = color.querySelector('p');
      color_name.textContent = title;

      const plus_icon = color.querySelector('span');
      plus_icon.style.display = 'none';

      const remove_button = color.querySelector('.remove-selected-color-2');
      remove_button.style.display = 'block';
      
      color.dataset.selected = true;
      color.dataset.id = id;
      break;
    }
  }

  for (const color of selected_colors_modal_2) {
    const isSelected = color.dataset.selected;

    if (!isSelected) {
      const img = color.querySelector('img');
      img.src = image;

      const color_plus = color.querySelector('span');
      color_plus.style.display = 'none';

      const color_name = color.querySelector('p');
      color_name.textContent = title;

      const remove_button = color.querySelector('.remove-selected-color-modal-2');
      remove_button.style.display = 'block';
      
      color.dataset.selected = true;
      break;
    }
  }

  const count = getSelectedCount2();
  selected_colors_count_2.textContent = count;

  if (nail_picker_progress_bar_2) {
    nail_picker_progress_bar_2.style.width = `${(100 / colors_number_2) * count}%`;
  }    

  if (count === colors_number_2) {
    const current_properties_block = document.getElementById('second-nail-picker-properties-block');
    if (current_properties_block) {
      current_properties_block.remove();
    }

    nail_picker_titles_2[0].style.display = 'none';
    nail_picker_titles_2[1].style.display = 'block';

    const hasFirstPickerUnselected = [...selected_colors_1].some(color => {
      const isSelected = color.dataset.selected;
      return isSelected === 'false' || !isSelected;
    });

    if (!hasFirstPickerUnselected) {
      atc_button_text.style.display = 'flex';
      choose_color_button_text.style.display = 'none';
      main_atc_button.type = 'submit';
    }    

    const properties_block = document.createElement('div');
    properties_block.setAttribute('id', 'second-nail-picker-properties-block');
    
    selected_colors_2.forEach((color, i) => {
      const id = color.dataset.id;

      const text_tag = color.querySelector('p');
      const title = text_tag.textContent;

      const img_tag = color.querySelector('img');
      const image = img_tag.src;

      const hiddenField1 = document.createElement('input');
      hiddenField1.setAttribute('type', "hidden");
      hiddenField1.setAttribute('class', `class${i + 1}`);
      hiddenField1.setAttribute('name', `items[2][properties][_${i + 1}.]`);
      hiddenField1.setAttribute('value', image);
      properties_block.appendChild(hiddenField1);        

      const hiddenField2 = document.createElement('input');
      hiddenField2.setAttribute('type', "hidden");
      hiddenField2.setAttribute('class', `class${i + 1}`);
      if (picker_type_2 === 'chrome') {
        hiddenField2.setAttribute('name', `items[2][properties][Chrome ${i + 1}]`);
      } else {
        hiddenField2.setAttribute('name', `items[2][properties][Colour ${i + 1}]`);
      }
      hiddenField2.setAttribute('value', title);
      properties_block.appendChild(hiddenField2);

      const hiddenField3 = document.createElement('input');
      hiddenField3.setAttribute('type', "hidden");
      hiddenField3.setAttribute('class', `class${i + 1}`);
      hiddenField3.setAttribute('name', `items[2][properties][_id${i + 1}.]`);
      hiddenField3.setAttribute('value', id);
      properties_block.appendChild(hiddenField3);
    });

    product_form.appendChild(properties_block);

    hidden_overlay.style.display = 'none';
    nail_picker_2.style.display = 'none';        
    document.body.style.overflow = 'auto';
    document.removeEventListener('click', closeOnClickOutside2);
  }
}

color_items_1.forEach(color_item => {
  color_item.addEventListener('click', (event) => {
    const current_color = event.currentTarget;
    const data_id = current_color.dataset.id;
    const data_title = current_color.dataset.title;
    const data_image = current_color.dataset.image;

    addColor1(data_id, data_image, data_title);
  });
});

color_items_2.forEach(color_item => {
  color_item.addEventListener('click', (event) => {
    const current_color = event.currentTarget;
    const data_id = current_color.dataset.id;
    const data_title = current_color.dataset.title;
    const data_image = current_color.dataset.image;

    addColor2(data_id, data_image, data_title);
  });
});

// ---------------------------------------------------------------

// REMOVE COLORS FROM PICKER
function removeProperties1() {
  const current_properties_block = document.getElementById('nail-picker-properties-block');

  if (current_properties_block) {
    current_properties_block.remove();

    nail_picker_titles_1[0].style.display = 'block';
    nail_picker_titles_1[1].style.display = 'none';
    
    atc_button_text.style.display = 'none';
    choose_color_button_text.style.display = 'flex';
    main_atc_button.type = 'button';
  }
}

function removeProperties2() {
  const current_properties_block = document.getElementById('second-nail-picker-properties-block');

  if (current_properties_block) {
    current_properties_block.remove();

    nail_picker_titles_2[0].style.display = 'block';
    nail_picker_titles_2[1].style.display = 'none';
    
    atc_button_text.style.display = 'none';
    choose_color_button_text.style.display = 'flex';
    main_atc_button.type = 'button';
  }
}

remove_selected_colors_1.forEach((item, i) => {
  item.addEventListener('click', (event) => {
    event.stopPropagation();
    const current_color = event.currentTarget;
    const parent = current_color.parentElement;
    const item_number = i;

    const img = parent.querySelector('img');
    img.src = selected_color_placeholder_1;

    const color_name = parent.querySelector('p');
    color_name.textContent = `Colour ${i + 1}`;

    const plus_icon = parent.querySelector('span');
    plus_icon.style.display = 'block';

    const remove_button = parent.querySelector('.remove-selected-color-1');
    remove_button.style.display = 'none';
    
    parent.removeAttribute('data-selected');
    parent.removeAttribute('data-id');

    selected_colors_modal_1.forEach((color, i) => {  
      if (i === item_number) {
        const img = color.querySelector('img');
        img.src = selected_color_placeholder_1;

        const color_name = color.querySelector('p');
        color_name.textContent = `Colour ${i + 1}`;

        const plus_icon = color.querySelector('span');
        plus_icon.style.display = 'block';

        //const color_name = color.querySelector('p');
        //color_name.style.display = 'block';

        const remove_button = color.querySelector('.remove-selected-color-modal-1');
        remove_button.style.display = 'none';
        
        color.removeAttribute('data-selected');
      }
    });

    const count = getSelectedCount1();
    selected_colors_count_1.textContent = count;

    if (nail_picker_progress_bar_1) {
      nail_picker_progress_bar_1.style.width = `${(100 / colors_number_1) * count}%`;
    }

    removeProperties1();
  });
});

remove_selected_colors_modal_1.forEach((item, i) => {
  item.addEventListener('click', (event) => {
    const current_color = event.currentTarget; 
    const parent = current_color.parentElement;
    const item_number = i;

    const img = parent.querySelector('img');
    img.src = selected_color_placeholder_1;

    const color_plus = parent.querySelector('span');
    color_plus.style.display = 'block';

    const color_name = parent.querySelector('p');
    color_name.textContent = `Colour ${i + 1}`;

    const remove_button = parent.querySelector('.remove-selected-color-modal-1');
    remove_button.style.display = 'none';
    
    parent.removeAttribute('data-selected');

    selected_colors_1.forEach((color, i) => {  
      if (i === item_number) {
        const img = color.querySelector('img');
        img.src = selected_color_placeholder_1;

        const color_name = color.querySelector('p');
        color_name.textContent = `Colour ${i + 1}`;

        const plus_icon = color.querySelector('span');
        plus_icon.style.display = 'block';

        const remove_button = color.querySelector('.remove-selected-color-1');
        remove_button.style.display = 'none';
        
        color.removeAttribute('data-selected');
        color.removeAttribute('data-id');
      }
    });

    const count = getSelectedCount1();
    selected_colors_count_1.textContent = count;

    if (nail_picker_progress_bar_1) {
      nail_picker_progress_bar_1.style.width = `${(100 / colors_number_1) * count}%`;
    }

    removeProperties1();
  });
});

remove_selected_colors_2.forEach((item, i) => {
  item.addEventListener('click', (event) => {
    event.stopPropagation();
    const current_color = event.currentTarget;
    const parent = current_color.parentElement;
    const item_number = i;

    const img = parent.querySelector('img');
    img.src = selected_color_placeholder_2;

    const color_name = parent.querySelector('p');
    color_name.textContent = `Colour ${i + 1}`;

    const plus_icon = parent.querySelector('span');
    plus_icon.style.display = 'block';

    const remove_button = parent.querySelector('.remove-selected-color-2');
    remove_button.style.display = 'none';
    
    parent.removeAttribute('data-selected');
    parent.removeAttribute('data-id');

    selected_colors_modal_2.forEach((color, i) => {  
      if (i === item_number) {
        const img = color.querySelector('img');
        img.src = selected_color_placeholder_2;

        const color_name = color.querySelector('p');
        color_name.textContent = `Colour ${i + 1}`;

        const plus_icon = color.querySelector('span');
        plus_icon.style.display = 'block';

        //const color_name = color.querySelector('p');
        //color_name.style.display = 'block';

        const remove_button = color.querySelector('.remove-selected-color-modal-2');
        remove_button.style.display = 'none';
        
        color.removeAttribute('data-selected');
      }
    });

    const count = getSelectedCount2();
    selected_colors_count_2.textContent = count;

    if (nail_picker_progress_bar_2) {
      nail_picker_progress_bar_2.style.width = `${(100 / colors_number_1) * count}%`;
    }

    removeProperties2();
  });
});

remove_selected_colors_modal_2.forEach((item, i) => {
  item.addEventListener('click', (event) => {
    const current_color = event.currentTarget; 
    const parent = current_color.parentElement;
    const item_number = i;

    const img = parent.querySelector('img');
    img.src = selected_color_placeholder_2;

    const color_plus = parent.querySelector('span');
    color_plus.style.display = 'block';

    const color_name = parent.querySelector('p');
    color_name.textContent = `Colour ${i + 1}`;

    const remove_button = parent.querySelector('.remove-selected-color-modal-2');
    remove_button.style.display = 'none';
    
    parent.removeAttribute('data-selected');

    selected_colors_2.forEach((color, i) => {  
      if (i === item_number) {
        const img = color.querySelector('img');
        img.src = selected_color_placeholder_2;

        const color_name = color.querySelector('p');
        color_name.textContent = `Colour ${i + 1}`;

        const plus_icon = color.querySelector('span');
        plus_icon.style.display = 'block';

        const remove_button = color.querySelector('.remove-selected-color-2');
        remove_button.style.display = 'none';
        
        color.removeAttribute('data-selected');
        color.removeAttribute('data-id');
      }
    });

    const count = getSelectedCount2();
    selected_colors_count_2.textContent = count;

    if (nail_picker_progress_bar_2) {
      nail_picker_progress_bar_2.style.width = `${(100 / colors_number_1) * count}%`;
    }

    removeProperties2();
  });
});

// ---------------------------------------------------------------

// CLEAR NAIL PICKER AFTER ADDING PRODUCT TO CART - working in cart drawer
window.clearTwoNailPickerOnPage = function() {
  selected_colors_1.forEach((item, i) => {
    const img = item.querySelector('img');
    img.src = selected_color_placeholder_1;

    const color_name = item.querySelector('p');
    color_name.textContent = `Colour ${i + 1}`;

    const plus_icon = item.querySelector('span');
    plus_icon.style.display = 'block';

    const remove_button = item.querySelector('.remove-selected-color-1');
    remove_button.style.display = 'none';
    
    item.removeAttribute('data-selected');
    item.removeAttribute('data-id');
  });

  selected_colors_modal_1.forEach((item, i) => {
    const img = item.querySelector('img');
    img.src = selected_color_placeholder_1;

    const color_plus = item.querySelector('span');
    color_plus.style.display = 'block';

    const color_name = item.querySelector('p');
    color_name.textContent = `Colour ${i + 1}`;

    const remove_button = item.querySelector('.remove-selected-color-modal-1');
    remove_button.style.display = 'none';
    
    item.removeAttribute('data-selected');
  });

  selected_colors_2.forEach((item, i) => {
    const img = item.querySelector('img');
    img.src = selected_color_placeholder_2;

    const color_name = item.querySelector('p');
    color_name.textContent = `Colour ${i + 1}`;

    const plus_icon = item.querySelector('span');
    plus_icon.style.display = 'block';

    const remove_button = item.querySelector('.remove-selected-color-2');
    remove_button.style.display = 'none';
    
    item.removeAttribute('data-selected');
    item.removeAttribute('data-id');
  });

  selected_colors_modal_2.forEach((item, i) => {
    const img = item.querySelector('img');
    img.src = selected_color_placeholder_2;

    const color_plus = item.querySelector('span');
    color_plus.style.display = 'block';

    const color_name = item.querySelector('p');
    color_name.textContent = `Colour ${i + 1}`;

    const remove_button = item.querySelector('.remove-selected-color-modal-2');
    remove_button.style.display = 'none';
    
    item.removeAttribute('data-selected');
  });

  selected_colors_count_1.textContent = 0;
  selected_colors_count_2.textContent = 0;

  removeProperties1();
  removeProperties2();

  if (nail_picker_progress_bar_1) {
    nail_picker_progress_bar_1.style.width = 0;
  }

  if (nail_picker_progress_bar_2) {
    nail_picker_progress_bar_2.style.width = 0;
  }
}
